import { ArrowLeftOutlined } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';
import { useBundle } from '@amzn/react-arb-tools';
import { getRecordType } from '@xbcb/core';
import { safeGetMessage } from '@xbcb/ui-utils';
import { AppRecordSecondaryHeaderContentProps } from 'routes';
import { getRecordPath } from 'libs/getRecordPath';
import { useWorkOrderTaskType } from 'libs/hooks';
import { StyledSpan } from './style';

const NavigateToWorkOrder: React.FC<AppRecordSecondaryHeaderContentProps> = ({
  record,
}) => {
  const [workOrderBundle] = useBundle('components.WorkOrder');
  const { taskType, taskId } = useWorkOrderTaskType();
  const { id } = record;

  const workOrderRecordType = getRecordType(id);

  const isTaskPage = Boolean(taskId) || taskType !== undefined;

  return workOrderRecordType && isTaskPage ? (
    <StyledSpan>
      <Link
        data-cy="back-to-work-order"
        to={getRecordPath({ recordType: workOrderRecordType, id })}
      >
        <ArrowLeftOutlined />
        {safeGetMessage(workOrderBundle, 'back_to_work_order')}
      </Link>
    </StyledSpan>
  ) : null;
};

export default NavigateToWorkOrder;
